import React from 'react';

const CAPABILITIES = [
  {
    icon: 'pi pi-sitemap',
    title: 'Startup at a different speed',
    copy:
      'The slowest, most manual work in clinical research is being rethought end to end. Work that takes weeks today is starting to take minutes. More on that soon.',
  },
  {
    icon: 'pi pi-comments',
    title: 'A workspace that answers back',
    copy:
      'Imagine asking your site a question in plain language — and getting an answer that knows exactly what you are allowed to see. That is the bar we are building to.',
  },
  {
    icon: 'pi pi-wave-pulse',
    title: 'Problems caught while they are small',
    copy:
      'Phennx is getting better at noticing what busy teams cannot — and putting it in front of the right person while it still matters.',
  },
];

const FLOW_STEPS = [
  { icon: 'pi pi-sparkles', label: 'AI proposes' },
  { icon: 'pi pi-eye', label: 'Human reviews' },
  { icon: 'pi pi-check-circle', label: 'Staff approve' },
  { icon: 'pi pi-history', label: 'Audit trail records' },
];

export default function AiAccountability() {
  return (
    <section className="hx-ai" id="ai" aria-labelledby="ai-heading">
      <div className="hx-container">
        <div className="hx-ai__grid">
          <div className="hx-ai__intro">
            <p className="hx-eyebrow">
              <span className="hx-eyebrow__tick" aria-hidden="true" />
              AI with accountability
            </p>
            <h2 className="hx-h2" id="ai-heading">
              The platform is learning.
              <br />
              Your team stays in charge.
            </h2>
            <p className="hx-lead">
              We are building intelligence into Phennx more deeply than we are ready to talk about.
              What we can say: AI drafts, summarizes, and flags — people decide. Every assisted step
              is human-reviewed, permission-scoped, and written to the audit trail like any other
              action in the system.
            </p>

            <ol className="hx-ai__flow" aria-label="How AI-assisted actions are controlled">
              {FLOW_STEPS.map((step, index) => (
                <li className="hx-ai__flow-step" key={step.label}>
                  <i className={`${step.icon} hx-ai__flow-icon`} aria-hidden="true" />
                  <span>{step.label}</span>
                  {index < FLOW_STEPS.length - 1 ? (
                    <i className="pi pi-arrow-right hx-ai__flow-arrow" aria-hidden="true" />
                  ) : null}
                </li>
              ))}
            </ol>
          </div>

          <ul className="hx-ai__cards">
            {CAPABILITIES.map((capability) => (
              <li className="hx-ai__card" key={capability.title}>
                <i className={`${capability.icon} hx-ai__card-icon`} aria-hidden="true" />
                <h3 className="hx-ai__card-title">{capability.title}</h3>
                <p className="hx-ai__card-copy">{capability.copy}</p>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
